import { FastField, Form, Formik } from 'formik';
import { useCallback } from 'react';
import { Button } from '@mui/material';

import { DealcalcErrModalWrapper } from '@styles/ContactManager/DealStyles';
import { NumberInputField } from '@shared/fields/NumberInputField';

import { Modal } from '@shared/components/modals/Modal';
import { dealCalcErrorSchema } from '../../../Deals/validation';

interface IDealCalculatorErrorModal {
  dealCalcHandler: (score: number) => void;
  handleClose: () => void;
  DealcalcErrModalPostiton: number;
}

interface DealCalcForm {
  estimatedScore: number;
}

const initialValues: DealCalcForm = {
  estimatedScore: 500,
};

export const DealcalculatorErrorModal = ({ dealCalcHandler, handleClose, DealcalcErrModalPostiton }: IDealCalculatorErrorModal) => {
  const handleSubmit = useCallback((data: DealCalcForm) => {
    dealCalcHandler(data.estimatedScore);
  }, []);

  return (
    <Modal 
      open
      hideBackdrop
      title="Deal Calculator Error" 
      dialogWidth="400px" 
      resetPosition={DealcalcErrModalPostiton}
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        validateOnChange
        validateOnMount
        initialValues={initialValues}
        validationSchema={dealCalcErrorSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form>
            <DealcalcErrModalWrapper>
              <FastField label="Estimated Score" name="estimatedScore" component={NumberInputField} />

              <Button sx={{ marginLeft: '10px' }} variant="contained" type="submit" disabled={!props.isValid}>
                Deal Calc
              </Button>
            </DealcalcErrModalWrapper>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
